<template>	
	<div class="w-full">		
		<h6 class="vs-input--label mb-3 mt-5">{{$t('MODULE.titleScala')}}</h6>
		<Options :index="index"></Options>
	</div>
</template>
<script type="text/javascript">	
	import Options from '../../componentsToQuestions/Options.vue';
	
	import { mapState } from 'vuex';

	export default {
		props: ['index'],
		components: { Options },
		
		computed: {
			...mapState('resource',['questionsByPage']),
		}
	}
	
</script>